import { Link, useLocation } from "react-router-dom"

export default function PLink({ to, ...props }) {
  const location = useLocation();

  return (
    <Link to={{ pathname: to, search: location.search }} {...props} />
  )
}